<template>
  <h1>Home?</h1>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "Home",
  setup() {
    const router = useRouter();
    router.push({name: 'ticketreports'});
  },
});
</script>
